import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from './Layout'
import api from '../services/api'

const nivelLabel = { 1:'Chefia imediata', 2:'RH / Gestão de pessoas', 3:'Financeiro' }

export default function Aprovacoes() {
  const navigate = useNavigate()
  const [aba, setAba] = useState('triagem')
  const [triagem, setTriagem] = useState([])
  const [aprovacoes, setAprovacoes] = useState([])
  const [load, setLoad] = useState(true)
  const [respondendo, setRespondendo] = useState(null)
  const [obs, setObs] = useState('')
  const [motivo, setMotivo] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => { carregar() }, [])

  async function carregar() {
    setLoad(true)
    try {
      const [t, a] = await Promise.all([
        api.get('/aprovacoes/triagem').then(r=>r.data).catch(()=>[]),
        api.get('/aprovacoes/pendentes').then(r=>r.data).catch(()=>[]),
      ])
      setTriagem(t); setAprovacoes(a)
    } catch {}
    setLoad(false)
  }

  async function aprovarTriagem(id) {
    setSalvando(true)
    try {
      await api.post(`/aprovacoes/triagem/${id}/aprovar`, { observacao: obs })
      setRespondendo(null); setObs(''); carregar()
    } catch(e) { alert(e.response?.data?.erro || 'Erro') }
    setSalvando(false)
  }

  async function rejeitarTriagem(id) {
    if (!motivo) { alert('Informe o motivo'); return }
    setSalvando(true)
    try {
      await api.post(`/aprovacoes/triagem/${id}/rejeitar`, { motivo })
      setRespondendo(null); setMotivo(''); carregar()
    } catch(e) { alert(e.response?.data?.erro || 'Erro') }
    setSalvando(false)
  }

  async function responderAprovacao(aprovacao_id, decisao) {
    setSalvando(true)
    try {
      await api.post(`/aprovacoes/${aprovacao_id}/responder`, { decisao, observacao: obs })
      setRespondendo(null); setObs(''); carregar()
    } catch(e) { alert(e.response?.data?.erro || 'Erro') }
    setSalvando(false)
  }

  const totalPendentes = triagem.length + aprovacoes.length

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 4px' }}>Aprovações pendentes</h1>
          <div style={{ fontSize:12, color:'#9ca3af' }}>Solicitações aguardando sua decisão</div>
        </div>
        {totalPendentes > 0 && (
          <div style={{ background:'#E24B4A', color:'white', borderRadius:99, padding:'4px 12px', fontSize:13, fontWeight:500 }}>
            {totalPendentes} pendente{totalPendentes>1?'s':''}
          </div>
        )}
      </div>

      {/* ABAS */}
      <div style={{ display:'flex', gap:0, marginBottom:20, background:'white', borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden', width:'fit-content' }}>
        {[
          { key:'triagem', label:'⏳ Triagem de solicitações', count:triagem.length },
          { key:'hierarquica', label:'✅ Aprovações hierárquicas', count:aprovacoes.length },
        ].map(a => (
          <div key={a.key} onClick={() => setAba(a.key)} style={{
            padding:'10px 18px', fontSize:13, cursor:'pointer',
            fontWeight:aba===a.key?500:400,
            color:aba===a.key?'#185FA5':'#6b7280',
            borderBottom:aba===a.key?'2px solid #185FA5':'2px solid transparent',
            background:aba===a.key?'#f0f7ff':'white',
            display:'flex', alignItems:'center', gap:6
          }}>
            {a.label}
            {a.count>0&&<span style={{ background:'#E24B4A', color:'white', borderRadius:99, fontSize:10, padding:'1px 6px', fontWeight:500 }}>{a.count}</span>}
          </div>
        ))}
      </div>

      {load
        ? <div style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>Carregando...</div>
        : <>
          {/* ABA TRIAGEM */}
          {aba==='triagem' && (
            triagem.length===0
              ? <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:40, textAlign:'center' }}>
                  <div style={{ fontSize:32, marginBottom:12 }}>✅</div>
                  <div style={{ fontSize:15, fontWeight:500, color:'#111', marginBottom:4 }}>Nenhuma solicitação pendente de triagem</div>
                  <div style={{ fontSize:13, color:'#9ca3af' }}>Solicitações abertas pelo portal do cidadão com aprovação prévia aparecerão aqui.</div>
                </div>
              : <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                  <div style={{ background:'#E6F1FB', border:'1px solid #B5D4F4', borderRadius:8, padding:12, fontSize:13, color:'#0C447C' }}>
                    💡 Estas solicitações foram abertas pelo portal do cidadão e precisam de aprovação antes de serem encaminhadas para o setor responsável.
                  </div>
                  {triagem.map(item => (
                    <div key={item.id} style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
                      <div style={{ padding:'16px 20px', borderBottom:'1px solid #f3f4f6' }}>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
                          <div>
                            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                              <span style={{ fontFamily:'monospace', fontSize:13, color:'#185FA5', fontWeight:600 }}>{item.numero}</span>
                              <span style={{ background:'#fef9c3', color:'#854d0e', padding:'2px 8px', borderRadius:99, fontSize:11, fontWeight:500 }}>⏳ Aguardando triagem</span>
                            </div>
                            <div style={{ fontSize:15, fontWeight:500 }}>{item.assunto}</div>
                            <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>
                              {item.tipo_nome} · Cidadão: <strong>{item.req_nome}</strong>
                              {item.req_cpf_cnpj ? ` · CPF: ${item.req_cpf_cnpj}` : ''}
                              {item.req_telefone ? ` · Tel: ${item.req_telefone}` : ''}
                            </div>
                            <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>
                              Aberto em {new Date(item.aberto_em).toLocaleString('pt-BR')}
                            </div>
                          </div>
                          <button onClick={() => navigate(`/processos/${item.id}`)}
                            style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, cursor:'pointer', background:'white', whiteSpace:'nowrap' }}>
                            Ver processo ↗
                          </button>
                        </div>

                        {item.dados_formulario && Object.keys(item.dados_formulario).length > 0 && (
                          <div style={{ marginTop:12, padding:12, background:'#f9fafb', borderRadius:8 }}>
                            <div style={{ fontSize:11, color:'#9ca3af', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.4px' }}>Dados da solicitação</div>
                            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 }}>
                              {Object.entries(item.dados_formulario).map(([k,v]) => (
                                <div key={k}>
                                  <div style={{ fontSize:11, color:'#6b7280' }}>{k}</div>
                                  <div style={{ fontSize:12, fontWeight:500, color:'#111' }}>{v}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      {respondendo === item.id ? (
                        <div style={{ padding:'16px 20px', background:'#f9fafb' }}>
                          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                            <div>
                              <div style={{ fontSize:12, fontWeight:500, marginBottom:6, color:'#374151' }}>✅ Aprovar — observação (opcional)</div>
                              <textarea value={obs} onChange={e=>setObs(e.target.value)}
                                placeholder="Mensagem para o cidadão..."
                                style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, minHeight:60, resize:'vertical', boxSizing:'border-box' }} />
                              <button onClick={() => aprovarTriagem(item.id)} disabled={salvando}
                                style={{ width:'100%', marginTop:8, padding:'8px', background:'#3B6D11', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                                {salvando?'Salvando...':'✅ Confirmar aprovação'}
                              </button>
                            </div>
                            <div>
                              <div style={{ fontSize:12, fontWeight:500, marginBottom:6, color:'#374151' }}>❌ Rejeitar — motivo (obrigatório)</div>
                              <textarea value={motivo} onChange={e=>setMotivo(e.target.value)}
                                placeholder="Informe o motivo da rejeição..."
                                style={{ width:'100%', padding:'8px 10px', border:'1px solid #fecaca', borderRadius:8, fontSize:12, minHeight:60, resize:'vertical', boxSizing:'border-box' }} />
                              <button onClick={() => rejeitarTriagem(item.id)} disabled={salvando}
                                style={{ width:'100%', marginTop:8, padding:'8px', background:'#A32D2D', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                                {salvando?'Salvando...':'❌ Confirmar rejeição'}
                              </button>
                            </div>
                          </div>
                          <button onClick={() => { setRespondendo(null); setObs(''); setMotivo('') }}
                            style={{ marginTop:10, padding:'6px 14px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, cursor:'pointer', background:'white' }}>
                            Cancelar
                          </button>
                        </div>
                      ) : (
                        <div style={{ padding:'12px 20px' }}>
                          <button onClick={() => { setRespondendo(item.id); setObs(''); setMotivo('') }}
                            style={{ padding:'8px 20px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                            Analisar solicitação
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
          )}

          {/* ABA APROVAÇÕES HIERÁRQUICAS */}
          {aba==='hierarquica' && (
            aprovacoes.length===0
              ? <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:40, textAlign:'center' }}>
                  <div style={{ fontSize:32, marginBottom:12 }}>✅</div>
                  <div style={{ fontSize:15, fontWeight:500, color:'#111', marginBottom:4 }}>Nenhuma aprovação hierárquica pendente</div>
                  <div style={{ fontSize:13, color:'#9ca3af' }}>Quando um processo precisar da sua aprovação como chefe ou gestor, aparecerá aqui.</div>
                </div>
              : <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                  {aprovacoes.map(item => (
                    <div key={item.aprovacao_id} style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
                      <div style={{ padding:'16px 20px', borderBottom:'1px solid #f3f4f6' }}>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
                          <div>
                            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                              <span style={{ fontFamily:'monospace', fontSize:13, color:'#185FA5', fontWeight:600 }}>{item.numero}</span>
                              <span style={{ background:'#FAEEDA', color:'#854F0B', padding:'2px 8px', borderRadius:99, fontSize:11 }}>
                                {nivelLabel[item.nivel]||`Nível ${item.nivel}`}
                              </span>
                            </div>
                            <div style={{ fontSize:15, fontWeight:500 }}>{item.assunto}</div>
                            <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>
                              {item.tipo_nome} · Solicitado por {item.req_nome} · {new Date(item.aberto_em).toLocaleDateString('pt-BR')}
                            </div>
                          </div>
                          <button onClick={() => navigate(`/processos/${item.id}`)}
                            style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, cursor:'pointer', background:'white', whiteSpace:'nowrap' }}>
                            Ver detalhes ↗
                          </button>
                        </div>
                      </div>

                      {respondendo === item.aprovacao_id ? (
                        <div style={{ padding:'16px 20px', background:'#f9fafb' }}>
                          <div style={{ marginBottom:10 }}>
                            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Observação (opcional)</label>
                            <textarea value={obs} onChange={e=>setObs(e.target.value)} placeholder="Adicione um comentário..."
                              style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, minHeight:60, resize:'vertical', boxSizing:'border-box' }} />
                          </div>
                          <div style={{ display:'flex', gap:8 }}>
                            <button onClick={() => responderAprovacao(item.aprovacao_id,'aprovado')} disabled={salvando}
                              style={{ flex:1, padding:'9px', background:'#3B6D11', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                              {salvando?'Salvando...':'✅ Aprovar'}
                            </button>
                            <button onClick={() => responderAprovacao(item.aprovacao_id,'rejeitado')} disabled={salvando}
                              style={{ flex:1, padding:'9px', background:'#A32D2D', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                              {salvando?'Salvando...':'❌ Rejeitar'}
                            </button>
                            <button onClick={() => { setRespondendo(null); setObs('') }}
                              style={{ padding:'9px 14px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
                              Cancelar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div style={{ padding:'12px 20px' }}>
                          <button onClick={() => { setRespondendo(item.aprovacao_id); setObs('') }}
                            style={{ padding:'8px 20px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                            Responder
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
          )}
        </>
      }
    </Layout>
  )
}
